import type { StoreMessageKey } from './store.en'

/** F5 store phone strings (Hindi), spread into hi.ts. The type forces every key in store.en.ts. */
export const storeHi: Record<StoreMessageKey, string> = {
  'store.devSeed': 'गोदाम का डेमो डेटा लोड करें',
  'store.transfer': 'दूसरी जगह भेजें',
  'store.transferHint': 'गोदाम या प्रोसेसिंग शेड के लिए गाड़ी लोड करें',
  'store.declaration': 'भंडार घोषणा',
  'store.declarationHint': 'बे के लिए बिना-फ्यूमिगेशन घोषणा',
  'store.stock': 'स्टॉक',
  'store.stockHint': 'जगहें, लॉट, गाड़ियाँ, लेबल जाँच',
  'store.redTie': 'लाल-टाई बोरियाँ',
  'store.redTieHint': 'साधारण लॉट की बोरियाँ स्कैन करें',

  'store.yes': 'हाँ',
  'store.no': 'नहीं',
  'store.saveFailed': 'फ़ोन में सेव नहीं हुआ',
  'store.removeBag': 'बोरी हटाएँ',
  'store.lots': 'लॉट',
  'store.lot': 'लॉट',
  'store.bags': 'बोरियाँ',
  'store.samples': 'सैंपल',
  'store.kgAtGate': 'कांटे पर किलो',
  'store.nOfM': '{m} में से {n}',
  'store.nOfMOn': '{m} में से {n} गाड़ी पर',
  'store.nOfMHere': '{m} में से {n} यहाँ',
  'store.bagsN': '{n} {n:बोरी|बोरियाँ}',
  'store.availableN': '{n} उपलब्ध',
  'store.heldN': '{n} रोक पर',
  'store.kgNowShort': 'अभी {kg}',
  'store.kgGateShort': 'कांटा {kg}',
  'store.daysHere': '{days} दिन से यहाँ',
  'store.refusedReported': '{count} लौटाए गए टैग की रिपोर्ट जाएगी',
  'store.up': 'एक स्तर ऊपर',
  'store.lotsHere': 'इस जगह के लॉट',
  'store.onDockShort': 'डॉक पर',
  'store.crop': 'फ़सल',
  'store.stream': 'धारा',
  'store.brand': 'ब्रांड (मुख्य)',
  'store.hold': 'रोक',
  'store.holdNone': 'कोई नहीं',
  'store.holdExplain': 'रोक पर: माल अपनी जगह रहता है और सुपरवाइज़र के हटाने तक उपलब्ध नहीं है।',
  'store.lotMissing': 'गायब',
  'store.onTrip': 'गाड़ी {code} पर',
  'store.elsewhere': 'दूसरी जगह',
  'store.lotNotHere': 'यह टैग इस गोदाम की सूची में नहीं है। नेटवर्क मिलने पर सूची अपडेट करें।',
  'store.lotLookupHint': 'लॉट का कोई भी टैग स्कैन करें',
  'store.noTrips': 'इस जगह के लिए कोई गाड़ी रास्ते में नहीं।',
  'store.tripFrom': '{from} से',
  'store.tripTo': '{to} को',
  'store.code': 'कोड',
  'store.level': 'स्तर',
  'store.use': 'उपयोग',
  'store.active': 'चालू',
  'store.labelCheckHint': 'नया लगाया लेबल स्कैन करें',
  'store.labelCheckConfirm': 'देखें कि यह नाम उसी जगह का है जहाँ लेबल लगा है।',
  'store.stockTab.places': 'जगहें',
  'store.stockTab.lot': 'लॉट',
  'store.stockTab.trips': 'गाड़ियाँ',
  'store.stockTab.label': 'लेबल',

  'store.cache.age': 'गोदाम सूची {when} डाउनलोड हुई',
  'store.cache.stale': 'गोदाम सूची एक दिन से पुरानी है',
  'store.cache.expired': 'गोदाम सूची बहुत पुरानी है — नेटवर्क मिलते ही अपडेट करें',
  'store.cache.update': 'गोदाम सूची अपडेट करें',
  'store.cache.needsNetwork': 'अपडेट के लिए नेटवर्क चाहिए',
  'store.cache.updated': 'गोदाम सूची अपडेट हुई',
  'store.cache.failed': 'गोदाम सूची अपडेट नहीं हुई',
  'store.cache.missingTitle': 'इस फ़ोन में गोदाम सूची नहीं है',
  'store.cache.missingBody':
    'नेटवर्क पर एक बार इस जगह की जगहें, लॉट और गाड़ियाँ डाउनलोड करें; फिर सब बिना नेटवर्क चलेगा।',

  'store.badge.hold': 'रोक पर',
  'store.badge.ordinary': 'साधारण',
  'store.badge.available': 'उपलब्ध',
  'store.badge.inTransit': 'रास्ते में',
  'store.badge.notAvailable': 'उपलब्ध नहीं',
  'store.badge.redTie': 'लाल टाई बाकी',
  'store.badge.notSynced': 'सिंक नहीं हुआ',
  'store.badge.heldAtOffice': 'ऑफ़िस ने रोका',
  'store.badge.syncProblem': 'सिंक में समस्या',

  'store.decl.clean': 'साफ़ घोषित',
  'store.decl.renewSoon': '{days} दिन में नवीनीकरण',
  'store.decl.notClean': 'साफ़ नहीं',
  'store.decl.expired': 'घोषणा की अवधि ख़त्म',
  'store.decl.oldForm': 'पुराना फ़ॉर्म — फिर से हस्ताक्षर करें',
  'store.decl.none': 'घोषणा नहीं',

  'store.role.STORAGE': 'भंडार',
  'store.role.CONVENTIONAL': 'लाल-टाई बे',
  'store.role.HOLD_AREA': 'रोक वाली जगह',
  'store.role.SAMPLE_STORE': 'सैंपल स्टोर',
  'store.role.DOCK': 'डॉक',

  'store.refusal.DUPLICATE': 'पहले ही स्कैन हो चुका',
  'store.refusal.TAG_WRONG_KIND': 'यहाँ यह कोड नहीं चलेगा',
  'store.refusal.TAG_NOT_BOUND': 'यह टैग किसी बोरी पर नहीं है',
  'store.refusal.TAG_VOID': 'रद्द टैग — बोरी अलग रखें; रिपोर्ट जाएगी',
  'store.refusal.TAG_RETIRED': 'इस्तेमाल हो चुका टैग — रिपोर्ट जाएगी',
  'store.refusal.TAG_UNKNOWN': 'अनजान टैग — रिपोर्ट जाएगी',
  'store.refusal.NOT_AT_ORIGIN': 'यह बोरी यहाँ नहीं रखी है',
  'store.refusal.ALREADY_LOADED': 'यह बोरी दूसरी गाड़ी पर है',
  'store.refusal.VEHICLE_NOT_CLEAN': 'गाड़ी का तल साफ़ नहीं: केवल साधारण (लाल-टाई) बोरियाँ',
  'store.refusal.NOT_STORED': 'यह बोरी गोदाम में नहीं है',
  'store.refusal.LEVEL_NOT_ALLOWED': 'बे या स्पॉट का लेबल स्कैन करें',
  'store.refusal.LOCATION_INACTIVE': 'यह जगह बंद है',
  'store.refusal.OTHER_SITE': 'दूसरा गोदाम — इसके लिए गाड़ी से भेजना होगा',
  'store.refusal.NOT_DECLARED': 'बे की साफ़ घोषणा नहीं है — पहले हस्ताक्षर करें',
  'store.refusal.CONV_IN_CLEAN_BAY': 'साधारण बोरी: केवल लाल-टाई बे में',
  'store.refusal.POSITION_HAS_OTHER_LOT': 'इस स्पॉट पर दूसरा लॉट है — खाली स्पॉट चुनें',
  'store.refusal.SAME_PLACE': 'पहले से इसी जगह पर',
  'store.refusal.NOT_A_BAY': 'बे का लेबल स्कैन करें (स्पॉट का नहीं)',
  'store.refusal.NOT_SAMPLE_STORE': 'सील केवल सैंपल स्टोर में',
  'store.refusal.NOT_YOUR_ROLL': 'आपके बदली-टैग रोल का नहीं',
  'store.refusal.TAG_ALREADY_USED': 'यह टैग पहले इस्तेमाल हो चुका',
  'store.refusal.OLD_TAG_NOT_HERE': 'यह बोरी इस जगह की नहीं — टैग गायब मानें',

  'store.load.stepTrip': 'गाड़ी',
  'store.load.stepBed': 'गाड़ी का तल',
  'store.load.stepScan': 'बोरियाँ स्कैन',
  'store.load.stepDispatch': 'रवाना',
  'store.load.destination': 'कहाँ जा रही है',
  'store.load.vehicleNo': 'गाड़ी नंबर',
  'store.load.driverName': 'ड्राइवर का नाम',
  'store.load.driverPhone': 'ड्राइवर का फ़ोन',
  'store.load.driverPhoneHint': '10 अंक',
  'store.load.challanNo': 'चालान नंबर',
  'store.load.challanHint': 'नंबर वाली चालान बुक से',
  'store.load.bedClean': 'गाड़ी का तल साफ़, कोई रसायन या खाद नहीं?',
  'store.load.bedLocked': 'बोरियाँ स्कैन हो चुकी हैं; जवाब बदलने के लिए उन्हें हटाएँ।',
  'store.load.bedDirtyTitle': 'ब्रांड बोरियाँ इस गाड़ी पर नहीं जा सकतीं',
  'store.load.bedDirtyBody': 'दूसरी गाड़ी लाएँ, या केवल साधारण (लाल-टाई) बोरियाँ लोड करें।',
  'store.load.onlyOrdinary': 'तल साफ़ नहीं: केवल साधारण (लाल-टाई) बोरियाँ ली जाएँगी।',
  'store.load.bagsOn': 'गाड़ी पर बोरियाँ',
  'store.load.samplesOn': 'गाड़ी पर सैंपल',
  'store.load.scanBag': 'बोरी का टैग',
  'store.load.scanSample': 'सैंपल सील',
  'store.load.scanToRemove': 'हटाने वाली बोरी स्कैन करें',
  'store.load.list': 'इस गाड़ी पर',
  'store.load.totals': 'कुल',
  'store.load.copyTotals': 'यह कुल चालान पर लिखें और ड्राइवर को दें।',
  'store.load.partialTitle': 'आधे लोड लॉट',
  'store.load.partialConfirm':
    '{lot}: {left} {left:बोरी अगली गाड़ी का इंतज़ार करेगी|बोरियाँ अगली गाड़ी का इंतज़ार करेंगी}',
  'store.load.handCount': 'गाड़ी पर गिनी बोरियाँ',
  'store.load.handCountHint': 'हाथ से गिनें; स्कैन की बोरियों के बराबर हो',
  'store.load.handCountMismatch': '{scanned} स्कैन की {scanned:बोरी|बोरियों} से मेल नहीं',
  'store.load.photo': 'गाड़ी की फ़ोटो',
  'store.load.photoHint': 'नंबर प्लेट दिखे',
  'store.load.lockedTitle': 'रवाना बंद है',
  'store.load.dispatch': 'रवाना करें',
  'store.load.dispatched': 'गाड़ी {code} रवाना',
  'store.load.block.DESTINATION': 'कहाँ जा रही है चुनें',
  'store.load.block.SAME_PLACE': 'जाने की जगह यही जगह है',
  'store.load.block.VEHICLE_NO': 'गाड़ी नंबर लिखें',
  'store.load.block.DRIVER_NAME': 'ड्राइवर का नाम लिखें',
  'store.load.block.DRIVER_PHONE': 'ड्राइवर का फ़ोन 10 अंक का हो',
  'store.load.block.CHALLAN_NO': 'चालान नंबर लिखें',
  'store.load.block.VEHICLE_CLEAN': 'गाड़ी के तल का जवाब दें',
  'store.load.block.NO_BAGS': 'कम से कम एक बोरी स्कैन करें',
  'store.load.block.HAND_COUNT': 'हाथ की गिनती स्कैन के बराबर हो',
  'store.load.block.PHOTO': 'गाड़ी की फ़ोटो लें',
  'store.load.block.PART_LOAD': 'हर आधे लोड लॉट को पक्का करें',

  'store.receive.arriving': 'आने वाली गाड़ी',
  'store.receive.noTrips': 'फ़ोन की सूची में इस गोदाम की ओर कोई गाड़ी नहीं।',
  'store.receive.tripLine': '{from} से · चालान {challan} · {bags} {bags:बोरी|बोरियाँ}',
  'store.receive.leftAt': '{when} निकली',
  'store.receive.notListed': 'गाड़ी सूची में नहीं — स्कैन करके रखें',
  'store.receive.heldTitle': 'इस गाड़ी की सूची फ़ोन पर नहीं आई',
  'store.receive.heldBody':
    'फिर भी बोरियाँ स्कैन करें। सूची आने पर माल प्राप्त खुलेगा; तब गाड़ी चुनें और ये स्कैन लें।',
  'store.receive.heldCount': 'रखे गए स्कैन',
  'store.receive.useHeld': '{count} रखे गए स्कैन लें',
  'store.receive.stepTrip': 'चालान',
  'store.receive.stepScan': 'उतारें',
  'store.receive.stepWeigh': 'जाँच वज़न',
  'store.receive.stepClose': 'बंद करें',
  'store.receive.trip': 'गाड़ी',
  'store.receive.challanCheck': 'चालान नंबर — ड्राइवर के कागज़ से मिलता है?',
  'store.receive.scanBag': 'बोरी का टैग या सैंपल सील',
  'store.receive.extrasTitle': '{count} {count:बोरी|बोरियाँ} सूची में नहीं',
  'store.receive.extrasBody': 'ये प्राप्त होंगी और तौली जाएँगी; ऑफ़िस फ़ैसला करेगा।',
  'store.receive.problemBags': 'समस्या वाली बोरी',
  'store.receive.problemBody':
    'इन बोरियों को रोक वाली जगह रखें और हर एक की फ़ोटो लें। ये हमारी नहीं मानी जाएँगी।',
  'store.receive.untagged': 'बिना टैग की बोरी',
  'store.receive.untaggedShort':
    'इस गाड़ी का एक लॉट कम है। बोरी अलग रखें और फटी बोरी / टैग गायब खोलें।',
  'store.receive.untaggedNoShort':
    'इस गाड़ी पर कुछ कम नहीं: बोरी साधारण अनाथ बनेगी। लाल-टाई बे में रखें और सुपरवाइज़र को बताएँ।',
  'store.receive.weighTitle': 'गोदाम के कांटे पर {count} {count:बोरी|बोरियाँ} तौलें',
  'store.receive.weighBody': 'एक बार में एक बोरी। कांटे पर तौलने वाले के अलावा कोई और तौले।',
  'store.receive.weigh': 'तौलें',
  'store.receive.nothingToWeigh': 'अभी तौलने को कोई बोरी नहीं — पहले बोरियाँ उतारें।',
  'store.receive.paperDay': 'कागज़ वाला दिन: हर बोरी',
  'store.receive.checkWeight': 'जाँच वज़न (किलो)',
  'store.receive.scale': 'तराज़ू: {name}',
  'store.receive.gateNet': 'कांटे का शुद्ध: {kg}',
  'store.receive.expectedNet': 'सूखने के बाद अपेक्षित: {kg} (सूखना {drying})',
  'store.receive.receiveNet': 'अभी शुद्ध (बोरी घटाकर): {kg}',
  'store.receive.within': 'सीमा में ({diff}, छूट {tol})',
  'store.receive.outside': 'सीमा से बाहर ({diff}, छूट {tol})',
  'store.receive.outOfTolTitle': 'फिर से तौलें',
  'store.receive.outOfTolBody':
    'पहला वज़न {first} सीमा से बाहर है। बोरी फिर कांटे पर रखें और वज़न दोबारा लिखें। फिर भी बाहर हो तो इस लॉट की हर बोरी तौलनी होगी।',
  'store.receive.confirmSecond': 'दूसरा वज़न सेव करें',
  'store.receive.sameWeigherTitle': 'यह बोरी आपने कांटे पर तौली थी',
  'store.receive.sameWeigherBody': 'कोई और फ़ोन खोलकर इसे तौले।',
  'store.receive.vehicleEmpty': 'गाड़ी खाली है',
  'store.receive.notScanned': '{count} स्कैन नहीं हुईं',
  'store.receive.emptyFirst': 'गायब लगाने से पहले गाड़ी खाली करें।',
  'store.receive.missingHint': 'जो बोरी गाड़ी पर नहीं थी, उस पर गायब दबाएँ।',
  'store.receive.missing': 'गायब',
  'store.receive.missingReason': 'क्यों गायब है?',
  'store.receive.lockedTitle': 'माल प्राप्त बंद है',
  'store.receive.block.NO_TRIP': 'गाड़ी की सूची फ़ोन पर नहीं आई',
  'store.receive.block.NOT_EMPTY': 'गाड़ी खाली है चुनें',
  'store.receive.block.OPEN_ITEMS':
    '{open} {open:बोरी न स्कैन हुई न गायब लगी|बोरियाँ न स्कैन हुईं न गायब लगीं}',
  'store.receive.block.CHECK_WEIGHTS':
    '{weights} {weights:चुनी बोरी|चुनी बोरियों} का जाँच वज़न बाकी',
  'store.receive.receive': 'प्राप्त करें',
  'store.receive.done': 'गाड़ी {code} प्राप्त',
  'store.receive.doneShort': 'गाड़ी {code} कम माल के साथ प्राप्त',

  'store.missingReason.NOT_ON_VEHICLE': 'गाड़ी पर नहीं थी',
  'store.missingReason.TAG_UNREADABLE': 'टैग नहीं पढ़ा जा रहा',
  'store.missingReason.DAMAGED_IN_TRANSIT': 'रास्ते में ख़राब',

  'store.place.label': 'जगह का लेबल',
  'store.place.newLabel': 'नई जगह का लेबल',
  'store.place.labelHint': 'लेबल स्कैन न हो तो नीचे छपा कोड टाइप करें।',
  'store.place.typed': 'टाइप किया',
  'store.place.notDeclaredWarn': 'साफ़ घोषणा नहीं: यहाँ ब्रांड बोरियाँ नहीं रखी जाएँगी।',
  'store.place.cleanWarn': 'साफ़ बे: यहाँ साधारण (लाल-टाई) बोरियाँ नहीं रखी जाएँगी।',
  'store.place.sampleStoreHint': 'सैंपल स्टोर: हर सील स्कैन करें।',
  'store.place.scanBag': 'बोरी का टैग',
  'store.place.scanSeal': 'सैंपल सील',
  'store.place.lotsHere': 'इस जगह लॉट की गिनती',
  'store.place.convBanner': 'इस सूची में साधारण (लाल-टाई) बोरियाँ — केवल लाल-टाई बे।',
  'store.place.from': '{place} से',
  'store.place.confirm': 'पुष्टि',
  'store.place.putAway': '{count} को {place} पर रखा',
  'store.place.moved': '{count} को {place} पर ले गए',
  'store.place.onDock': '{count} {count:बोरी|बोरियाँ} डॉक पर इंतज़ार में',

  'store.declaration.bayLabel': 'बे का लेबल',
  'store.declaration.due': '{count} बे की घोषणा बाकी',
  'store.declaration.validTo': '{date} तक मान्य',
  'store.declaration.photo': 'हस्ताक्षर किए फ़ॉर्म की फ़ोटो',
  'store.declaration.validUntil': 'मान्य तक',
  'store.declaration.form': 'फ़ॉर्म',
  'store.declaration.notCleanTitle': 'इन जवाबों से बे साफ़ नहीं रहेगी',
  'store.declaration.notCleanBody':
    'यहाँ ब्रांड बोरियाँ नहीं जा सकेंगी, और इसमें पहले से रखी {count} ब्रांड {count:बोरी अपनी जगह रोक पर रहेगी|बोरियाँ अपनी जगह रोक पर रहेंगी}।',
  'store.declaration.sign': 'हस्ताक्षर करें',
  'store.declaration.paperHint': 'फ़ोटो से पहले छपे फ़ॉर्म पर यही जवाब देकर हस्ताक्षर करें।',
  'store.declaration.signed': '{bay} की घोषणा पर हस्ताक्षर हुए',

  'store.count.requests': 'ऑफ़िस ने {count} गिनती माँगी',
  'store.count.seen': 'देखी',
  'store.count.extra': 'अपेक्षित नहीं',
  'store.count.scanTag': 'यहाँ का हर टैग स्कैन करें',
  'store.count.shortBy': '{n} कम',
  'store.count.nothingExpected': 'फ़ोन के हिसाब से यहाँ कोई बोरी नहीं।',
  'store.count.extraTitle': 'बोरियाँ जो कहीं और होनी चाहिए',
  'store.count.unknownTitle': 'कोड जो चालू बोरी नहीं हैं',
  'store.count.done': 'गिनती पूरी',
  'store.count.matched': 'गिनती मिल गई',
  'store.count.mismatch': 'गिनती नहीं मिली — ऑफ़िस देखेगा',
  'store.count.sent': 'गिनती सेव हुई',
  'store.count.sentBody': 'यह ऑफ़िस से सिंक होगी। यहाँ फटी बोरी या बिना टैग की बोरी मिली?',

  'store.replace.title': 'फटी बोरी / टैग गायब',
  'store.replace.hint': 'नई बोरी, आपके रोल से नया टैग',
  'store.replace.countFirst': 'पहले उस जगह की गिनती करें जहाँ बोरी मिली।',
  'store.replace.countDone': 'गिनती पूरी — आगे बढ़ें',
  'store.replace.noShort': 'यहाँ कोई लॉट कम नहीं: बिना टैग की बोरी साधारण अनाथ बनेगी।',
  'store.replace.oldTag': 'पुराना टैग',
  'store.replace.oldTagHint': 'केवल अगर अभी बोरी पर लगा है',
  'store.replace.callSupervisor': 'पुराना टैग गायब: सुपरवाइज़र को बुलाएँ।',
  'store.replace.newTag': 'नया टैग',
  'store.replace.newTagHint': 'आपके बदली रोल का होना चाहिए',
  'store.replace.sackType': 'बोरी का प्रकार',
  'store.replace.weight': 'नई बोरी का वज़न (किलो)',
  'store.replace.newNet': 'नया शुद्ध (बोरी घटाकर): {kg}',
  'store.replace.heavier': 'पुरानी बोरी से भारी — सुपरवाइज़र जाँचेगा',
  'store.replace.candidate': '{lot} के {tag} से मेल ({kg})',
  'store.replace.noCandidate': 'एक मेल नहीं ({n} संभव) — यह साधारण अनाथ बनेगी',
  'store.replace.photo': 'फ़ोटो',
  'store.replace.crop': 'फ़सल',
  'store.replace.cutOldTag': 'पुराना टैग काटें और सुपरवाइज़र के लिए रखें।',
  'store.replace.replace': 'बदलें',
  'store.replace.done': 'बदली सेव हुई',
  'store.replace.waitSupervisor': 'सुपरवाइज़र के जाँचने तक नई बोरी यहीं रोक पर रहेगी।',
  'store.replace.recent': 'इस फ़ोन से बदली',
  'store.replace.lostTag': 'टैग गायब',
  'store.replace.statusPending': 'सिंक का इंतज़ार।',
  'store.replace.statusReview': 'रोक पर, सुपरवाइज़र के सही या रद्द करने का इंतज़ार।',
  'store.replace.statusOrphan':
    'साबित नहीं: यह साधारण अनाथ बनेगी। लाल टाई लगाएँ, स्कैन करें और लाल-टाई बे में ले जाएँ।',
  'store.replace.statusError': 'सिंक में समस्या — सिंक खोलें।',
  'store.replace.evidence.OLD_TAG': 'पुराना टैग स्कैन हुआ',
  'store.replace.evidence.COUNT_AND_WEIGHT': 'गिनती और वज़न मेल',
  'store.replace.evidence.NONE': 'कोई सबूत नहीं',

  'store.redTieList': '{count} {count:बोरी|बोरियों} पर लाल टाई बाकी',
  'store.redTieNone': 'किसी बोरी पर लाल टाई बाकी नहीं।',
  'store.redTieScan': 'टैग (लाल टाई लगी)',
  'store.redTieNotListed': 'यह बोरी लाल-टाई सूची में नहीं है',
  'store.redTieDone': '{count} {count:बोरी साधारण लगाई गई|बोरियाँ साधारण लगाई गईं}',
  'store.redTieMoveNext': 'अब इन्हें लाल-टाई बे {bay} में ले जाएँ और वहाँ स्कैन करें।',

  // Seva Mandir V1 store screens (alignment map V1-F5 boards).
  'store.v1.home.title': '{site} · आज',
  'store.v1.home.arriving': 'आ रही गाड़ियाँ',
  'store.v1.home.none': 'अभी कोई गाड़ी नहीं आ रही',
  'store.v1.home.refresh': 'सूची ताज़ा करें',
  'store.v1.home.form': 'गोदाम का फ़ॉर्म',
  'store.v1.home.send': 'माल भेजें',
  'store.v1.home.dock': '{count} {count:बोरी|बोरियाँ} जगह पर रखनी हैं',
  'store.v1.home.dockLine': 'डॉक पर उतरी हैं। बे में रखें',
  'store.v1.more.putAway': 'बोरियाँ जगह पर रखें',
  'store.v1.more.putAwayLine': 'डॉक से बे या जगह पर',
  'store.v1.hold.line': 'ऑफ़िस ने यह लॉट रोका है: {reason}',
  'store.v1.hold.lineNoReason': 'ऑफ़िस ने यह लॉट रोका है। सुपरवाइज़र से पूछें',
  'store.v1.hold.reason.storage': 'भंडार का जोखिम',
  'store.v1.hold.reason.paper': 'कागज़ वाला दिन, जाँच बाकी',
  'store.v1.hold.reason.labFail': 'लैब जाँच में फ़ेल',
  'store.v1.hold.reason.labTest': 'लैब जाँच बाकी',
  'store.v1.hold.reason.quality': 'माल की जाँच',
  'store.v1.hold.reason.moisture': 'नमी ज़्यादा',
  'store.v1.hold.reason.weight': 'वज़न की जाँच',
  'store.v1.hold.reason.count': 'बोरियों की गिनती नहीं मिली',
  'store.v1.hold.reason.run': 'मशीन के काम में दिक्कत',
  'store.v1.more.title': 'दूसरे काम',
  'store.v1.more.move': 'बोरियाँ हटाएँ',
  'store.v1.more.moveLine': 'गोदाम में एक जगह से दूसरी जगह',
  'store.v1.more.count': 'खाना गिनें',
  'store.v1.more.countLine': 'ऑफ़िस कहे तो बोरियाँ गिनें',
  'store.v1.more.stock': 'क्या कहाँ है',
  'store.v1.more.stockLine': 'जगह या बोरी स्कैन करके देखें',
  'store.v1.more.redTie': 'लाल टाई बोरियाँ',
  'store.v1.more.redTieLine': 'साधारण माल, अलग रखा',
  'store.v1.more.replace': 'फटी बोरी',
  'store.v1.more.replaceLine': 'माल नई बोरी में डालें',
  'store.v1.more.issue': 'मशीन को बोरियाँ',
  'store.v1.more.issueLine': 'गोदाम से बोरियाँ मशीन को दें',
  'store.v1.put.title': 'बोरियाँ जगह पर रखें',
  'store.v1.put.scanPlace': 'जगह का लेबल स्कैन करें',
  'store.v1.put.placeFirst': 'पहले उस **खाने या जगह** का लेबल स्कैन करें जहाँ बोरियाँ रखनी हैं',
  'store.v1.put.onDock': '{count} बोरी उतरी हैं, अभी जगह पर नहीं',
  'store.v1.put.change': 'जगह बदलें',
  'store.v1.put.notDeclared': 'गोदाम का फ़ॉर्म नहीं भरा: अच्छी बोरियाँ अभी यहाँ नहीं रख सकते',
  'store.v1.put.placed': 'रखीं',
  'store.v1.put.removeLast': 'आखिरी हटाएँ',
  'store.v1.put.band': '{grade} · {lot} · {n}/{m} यहाँ',
  'store.v1.put.samples': '{count} सैंपल',
  'store.v1.put.confirm': 'बोरियाँ रख दीं',
  'store.v1.put.doneTitle': 'बोरियाँ रख दीं',
  'store.v1.put.doneLine': '**{count}** बोरी **{place}** पर',
  'store.v1.put.doneChip': 'गोदाम की सूची में अब ये अपनी जगह पर हैं',
  'store.v1.home.receive': 'माल उतारें',
  'store.v1.home.held': 'गाड़ी …{digits}: {count} बोरी, मिलान बाकी',
  'store.v1.tripLine': '{village} · {count} बोरी',
  'store.v1.ago.min': '{n} मिनट',
  'store.v1.ago.hour': '{n} घंटे',
  'store.v1.ago.day': '{n} दिन',
  'store.v1.cache.title': 'गोदाम की सूची डाउनलोड करें',
  'store.v1.cache.body':
    'इस फ़ोन में अभी बोरियों और गाड़ियों की सूची नहीं है। इंटरनेट से जोड़कर डाउनलोड करें।',
  'store.v1.cache.download': 'डाउनलोड करें',
  'store.v1.cache.offline': 'इंटरनेट नहीं है',
  'store.v1.cache.stale': 'सूची पुरानी है: इंटरनेट मिलने पर ताज़ा करें',
  'store.v1.cache.failed': 'डाउनलोड नहीं हुआ। फिर से करें।',
  'store.v1.saveFailed': 'फ़ोन में सेव नहीं हुआ। फिर से करें।',
  'store.v1.tag': 'टैग {tag}',
  'store.v1.farmerNo': '{name} · नं. {no}',
  'store.v1.typeTitle': 'टैग नंबर',
  'store.v1.typeNotFound': 'इस नंबर की बोरी नहीं मिली। टैग स्कैन करें।',
  'store.v1.typePlaceTitle': 'जगह का नंबर',
  'store.v1.typePlaceNotFound': 'इस नंबर की एक जगह नहीं मिली। नीचे सूची से चुनें।',
  'store.v1.placeList.title': 'या जगह चुनें',
  'store.v1.placeList.line': '{code} · {count} बोरी',
  'store.v1.supervisor': 'सुपरवाइज़र',
  'store.v1.home': 'घर',
  'store.v1.band.good': 'अच्छा माल',
  'store.v1.band.red': 'लाल टाई माल',
  'store.v1.lots': 'लॉट',
  'store.v1.bags': 'बोरी',
  'store.v1.kg': 'माल किलो',
  'store.v1.load.title': 'गाड़ी में चढ़ाएँ',
  'store.v1.load.where': 'कहाँ जा रही?',
  'store.v1.load.change': 'बदलें',
  'store.v1.load.which': 'कौन सी गाड़ी?',
  'store.v1.load.lastTime': 'पिछली बार {date}',
  'store.v1.load.newVehicle': 'नई गाड़ी',
  'store.v1.load.plate': '**नंबर प्लेट** देखकर चुनें',
  'store.v1.load.pickDest': 'कहाँ जा रही, चुनें',
  'store.v1.load.pickVehicle': 'गाड़ी चुनें',
  'store.v1.load.typeTitle': 'गाड़ी नंबर',
  'store.v1.load.typeHint': 'जैसा नंबर प्लेट पर लिखा है',
  'store.v1.load.noDest': 'सूची में कोई गोदाम नहीं। सूची ताज़ा करें।',
  'store.v1.scanOn.title': 'बोरियाँ चढ़ाएँ',
  'store.v1.scanOn.hold': 'टैग दिखाएँ',
  'store.v1.scanOn.on': 'चढ़ीं',
  'store.v1.scanOn.moreLots': 'और {count} लॉट',
  'store.v1.scanOn.lotsLine': '{full} पूरे · {left} बाकी',
  'store.v1.scanOn.lotsTitle': 'गाड़ी पर लॉट',
  'store.v1.scanOn.remove': 'बोरी हटाएँ',
  'store.v1.scanOn.done': 'गाड़ी भर गई',
  'store.v1.scanOn.first': 'पहली बोरी का टैग',
  'store.v1.fixLast.title': 'पिछली बोरी हटाएँ?',
  'store.v1.fixLast.body': 'ग़लती से स्कैन हुई? सूची से हटाएँ।',
  'store.v1.fixLast.yes': 'हाँ, हटाएँ',
  'store.v1.remove.hint': 'उतारने वाली बोरी का टैग दिखाएँ',
  'store.v1.remove.notOn': 'यह बोरी गाड़ी पर नहीं',
  'store.v1.remove.removed': 'टैग {tag} हटा',
  'store.v1.remove.done': 'हो गया',
  'store.v1.refused.load': 'टैग {tag} नहीं चढ़ेगा',
  'store.v1.refused.receive': 'टैग {tag} नहीं लिया',
  'store.v1.refused.what': 'अब क्या करें',
  'store.v1.refused.loadStep1': 'बोरी **उतारकर अलग** रखें',
  'store.v1.refused.loadStep2': 'सुपरवाइज़र को **फ़ोन** करें',
  'store.v1.refused.receiveStep1': 'बोरी **अलग** रखें',
  'store.v1.refused.receiveStep2': 'सुपरवाइज़र को **बताएँ**',
  'store.v1.refused.notOurs': 'यह बोरी हमारी नहीं',
  'store.v1.refused.gotIt': 'समझ आ गया',
  'store.v1.problem.title': 'समस्या वाली बोरी',
  'store.v1.why.NOT_AT_ORIGIN': 'दूसरी जगह का टैग',
  'store.v1.why.ALREADY_LOADED': 'पहले से गाड़ी पर',
  'store.v1.why.NOT_STORED': 'यह बोरी भेज नहीं सकते',
  'store.v1.why.TAG_VOID': 'रद्द टैग',
  'store.v1.why.TAG_RETIRED': 'पुराना टैग',
  'store.v1.why.TAG_UNKNOWN': 'टैग सूची में नहीं',
  'store.v1.why.TAG_WRONG_KIND': 'यह बोरी का टैग नहीं',
  'store.v1.why.OTHER': 'नहीं चढ़ सकती',
  'store.v1.count.title': 'बोरियाँ हाथ से गिनें',
  'store.v1.count.label': 'गाड़ी पर बोरियाँ',
  'store.v1.count.type': 'गिनती लिखें',
  'store.v1.dispatch.title': 'गाड़ी रवाना करें?',
  'store.v1.dispatch.going': '{place} जा रही',
  'store.v1.dispatch.handCount': 'हाथ से गिनी',
  'store.v1.dispatch.countOff': 'गिनी {count}, स्कैन {scanned}: फिर गिनें',
  'store.v1.dispatch.locked': 'रवाना के बाद बोरी **हटा या जोड़ नहीं** सकते',
  'store.v1.dispatch.yes': 'हाँ, रवाना',
  'store.v1.dispatched.title': 'गाड़ी रवाना',
  'store.v1.dispatched.line': '{bags} बोरी · {lots} लॉट',
  'store.v1.dispatched.rescan': 'पहुँचने पर हर बोरी फिर स्कैन होगी',
  'store.v1.pick.title': 'कौन सी गाड़ी आई?',
  'store.v1.pick.unknown': 'गाड़ी सूची में नहीं',
  'store.v1.pick.matched': '{count} बोरी पहले से स्कैन',
  'store.v1.unknown.later': 'माल उतारें, **मिलान बाद में**',
  'store.v1.unknown.digits': 'गाड़ी नंबर के आख़िरी 4 अंक',
  'store.v1.unknown.wait': '4 अंक लिखें',
  'store.v1.scanOff.title': 'बोरियाँ उतारें',
  'store.v1.scanOff.off': 'उतरीं',
  'store.v1.scanOff.band': '{grade} · {lot} · {n}/{m} उतरीं',
  'store.v1.scanOff.receive': 'माल लें',
  'store.v1.scanOff.first': 'पहली बोरी का टैग',
  'store.v1.held.vehicle': 'गाड़ी …{digits}',
  'store.v1.held.later': 'सूची बाद में',
  'store.v1.held.saved': 'टैग {tag} सेव · मिलान बाकी',
  'store.v1.held.allOff': 'सब उतर गईं',
  'store.v1.short.title': 'माल लें? {count} बोरी कम',
  'store.v1.short.off': 'उतरीं {n} / {m}',
  'store.v1.short.look': 'तिरपाल के नीचे, **केबिन** में देखें',
  'store.v1.short.warn':
    '"हाँ" के बाद {count:यह बोरी|ये बोरियाँ} **गायब** मानी {count:जाएगी|जाएँगी}',
  'store.v1.short.back': 'पीछे, और देखें',
  'store.v1.short.yes': 'हाँ, माल लें',
  'store.v1.received.title': 'माल लिया',
  'store.v1.received.bags': '**{count}** बोरी मिलीं',
  'store.v1.received.lots': '{count} लॉट अब **{place}** में',
  'store.v1.received.missing': '{count} बोरी गायब: ऑफ़िस देखेगा',
  'store.v1.form.title': 'गोदाम का फ़ॉर्म',
  'store.v1.form.one': 'पूरे गोदाम का एक फ़ॉर्म',
  'store.v1.form.step1': 'छपे फ़ॉर्म पर **साइन** करें',
  'store.v1.form.step2': 'साइन वाले फ़ॉर्म की **फोटो** लें',
  'store.v1.form.step3': 'फ़ॉर्म पर लिखे **जवाब** चुनें',
  'store.v1.form.paper': 'साइन वाला फ़ॉर्म',
  'store.v1.form.taken': 'फोटो ली',
  'store.v1.form.again': 'फिर से',
  'store.v1.form.take': 'फोटो लें',
  'store.v1.form.yes': 'हाँ',
  'store.v1.form.no': 'नहीं',
  'store.v1.form.metres': '{n} मीटर',
  'store.v1.form.sign': 'फ़ॉर्म जमा करें',
  'store.v1.form.waitPhoto': 'फ़ॉर्म की फोटो',
  'store.v1.form.waitAnswers': 'जवाब चुनें',
  'store.v1.form.inForce': 'फ़ॉर्म {date} तक चालू',
  'store.v1.signed.title': '{place} का फ़ॉर्म जमा',
  'store.v1.signed.until': 'कब तक: {date}',
  'store.v1.signed.whole': 'पूरे गोदाम के लिए',
  'store.v1.form.noBays': 'इस गोदाम में अभी कोई बे नहीं। ऑफ़िस से पूछें।',
}
